import React, { useState } from 'react'
import { IoLogoWhatsapp } from "react-icons/io";
import { IoMdCall } from "react-icons/io";
import { MdSupportAgent } from "react-icons/md";
const FabButton = () => {
  const [isHide, setIsHide] = useState(false)
  const redirectToWhatsApp = () => {
    const phoneNumber = '7988066536';
    const whatsappLink = `https://api.whatsapp.com/send?phone=91${phoneNumber}`;
    window.location.href = whatsappLink;
  };
  return (
    <div className=' fixed bottom-6 right-2 hidden max-sm:block z-50 '>
{isHide && (<><span className=' fixed right-6 bottom-28 ' >
  <IoLogoWhatsapp color='green' size={28} onClick={redirectToWhatsApp}/> 
</span>
<a className=' fixed right-6 bottom-40' href="tel:7988066536">
  <IoMdCall color='blue' size={28} />
</a></>)}
      <div className=' shadow-lg bg-[#510069] h-[60px] w-[60px] rounded-full flex items-center justify-center' onClick={()=>setIsHide(!isHide)}>
      <span className=' text-white text-sm font-bold'><MdSupportAgent size={28}/></span>
      </div>
    </div>
  )
}

export default FabButton
